import { render, staticRenderFns } from "./addColumnsPopup.vue?vue&type=template&id=06f68bac&scoped=true&"
import script from "./addColumnsPopup.vue?vue&type=script&lang=js&"
export * from "./addColumnsPopup.vue?vue&type=script&lang=js&"
import style0 from "./addColumnsPopup.vue?vue&type=style&index=0&id=06f68bac&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f68bac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06f68bac')) {
      api.createRecord('06f68bac', component.options)
    } else {
      api.reload('06f68bac', component.options)
    }
    module.hot.accept("./addColumnsPopup.vue?vue&type=template&id=06f68bac&scoped=true&", function () {
      api.rerender('06f68bac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/views/listView/table/addColumnsPopup.vue"
export default component.exports